import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=c9de81a2&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=ts&"
export * from "./MainMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=c9de81a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9de81a2",
  null
  
)

export default component.exports